module.exports = __webpack_public_path__ + "img/pickhero.d5a868a1.svg";